<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <!--<div class="left-side-switch" onclick="sideChangeStatus();">
      <i class="fa" :class="status ? 'fa-angle-double-right':'fa-angle-double-left'"></i>
    </div>-->
    <div>
      <h6
        class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
      >
        {{ $t("product.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="mg-b-10 form-group">
          <input
            type="text"
            :placeholder="$t('product.自定义名称')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate"
            v-model.trim="name"
          />
        </div>
        <div class="mg-b-10 form-group">
          <input
            type="text"
            :placeholder="$t('product.1688账号名')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate"
            v-model.trim="resourceOwner"
          />
        </div>
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            @change="filtrate"
            v-model="authStatus"
          >
            <option value="">{{ $t("product.选择授权状态") }}</option>
            <option v-for="(s, k) in authStatusArr" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
        <div class="mg-b-20 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            @change="filtrate"
            v-model="useStatus"
          >
            <option value="">{{ $t("product.选择启用状态") }}</option>
            <option v-for="(s, k) in authUseStatusArr" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
      @click="filtrate"
    >
      {{ $t("product.筛 选") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["status", "fName", "fResourceOwner", "fAuthStatus", "fUseStatus"],
  data() {
    return {
      authStatusArr: arrDict.auth1688Status,
      authUseStatusArr: arrDict.auth1688UseStatus,
      name: "", //$t('product.自定义名称')
      resourceOwner: "", //$t('product.账号名')
      authStatus: "",
      useStatus: "",
    };
  },
  watch: {
    fName: function () {
      this.name = this.fName;
    },
    fResourceOwner: function () {
      this.resourceOwner = this.fResourceOwner;
    },
    fAuthStatus: function () {
      this.authStatus = this.fAuthStatus;
    },
    fUseStatus: function () {
      this.useStatus = this.fUseStatus;
    },
  },
  methods: {
    filtrate() {
      this.$emit(
        "filtrate",
        this.name,
        this.resourceOwner,
        this.authStatus,
        this.useStatus
      );
    },
  },
  mounted() {
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  updated() {
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
};
</script>